import { render, staticRenderFns } from "./comforswiper.vue?vue&type=template&id=6bce640a&scoped=true&"
import script from "./comforswiper.vue?vue&type=script&lang=js&"
export * from "./comforswiper.vue?vue&type=script&lang=js&"
import style0 from "./comforswiper.vue?vue&type=style&index=0&id=6bce640a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bce640a",
  null
  
)

export default component.exports